export const customSelectBoxStyles = {
    container: (style: any) => ({
        ...style,
        width: "100%",
    }),
    control: (style: any) => ({
        ...style,
        minHeight: "45px",
        borderRadius: "0px",
        border: "1px solid #ced4da;",
        fontStyle: 'Roboto',
        fontSize: "12px",
        color: "rgba(0, 0, 0, 0.5);",
        textTransform: "capitalize",
    }),
    menuList: (style: any) => ({
        ...style,
        maxHeight: '120px',
    }),
    menu: (style: any) => ({
        ...style,
        width: "100%",
        fontSize: "13px",
        maxHeight: '120px',
        textTransform: "capitalize",
        zIndex: "99",
    }),
    indicatorSeparator: () => ({
        display: "none",
    })
}
